module.exports = __webpack_public_path__ + "db151dc2.svg";